import { useContext } from "react";

import { LocaleContext } from "../../components/users/ContextProvider/LocaleContext";

export function useIsDark(): boolean {
  return useTheme().isDark;
}

export function useTheme() {
  const { themeMode, setThemeMode, isDark } = useContext(LocaleContext);

  return { themeMode, setThemeMode, isDark };
}
